import { ROUTES_PATH } from 'app/constants/Routes';

const RESTRICTED_PAYWALL_EXEMPT_PATHS = [
  ROUTES_PATH.CONFIGURACOES.ACCOUNT_PROFILE,
  ROUTES_PATH.CONFIGURACOES.PLAN_AND_PAYMENT,
  ROUTES_PATH.CONFIGURACOES.SECURITY,
];

export function isRestrictedPaywallExemptPath(pathname: string): boolean {
  return RESTRICTED_PAYWALL_EXEMPT_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

export function getRestrictedPaywallRedirectPath(): string {
  return ROUTES_PATH.CONFIGURACOES.PLAN_AND_PAYMENT;
}

type ShouldRedirectToPaywallParams = {
  isRestricted: boolean;
  isSubscriptionStatusLoading: boolean;
  isExemptPath: boolean;
  isPollingCredits: boolean;
};

export function shouldRedirectToPaywall({
  isRestricted,
  isSubscriptionStatusLoading,
  isExemptPath,
  isPollingCredits,
}: ShouldRedirectToPaywallParams): boolean {
  return (
    isRestricted &&
    !isSubscriptionStatusLoading &&
    !isExemptPath &&
    !isPollingCredits
  );
}
